export default __webpack_public_path__ + "static/media/transferenciaLogo.43f8995d.png";